// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unit-container {
  padding: 5px 8px;
  height: 100%;
  overflow: auto;
}
.unit-container .unit-header {
  height: 41px;
  border-bottom: 1px solid #ddd;
}
.unit-container .unit-image {
  padding: 20px 0 5px 0;
}
.unit-container .unit-image svg {
  max-width: 100%;
  max-height: 100%;
}
.unit-warn {
  color: #FF8A00;
}
.unit-warn .unit-path {
  stroke: #FF8A00;
}
.unit-ok {
  color: green;
}
.unit-ok .unit-path {
  stroke: green;
}
.unit-error {
  color: red;
}
.unit-error .unit-path {
  stroke: red;
}
.show-manual-color .manual-value {
  color: #1677ff;
}
.manual-value {
  color: #1677ff;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/RightPanel/UnitPanel/unit.less"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;AAAF;AAHA;EAMI,YAAA;EACA,6BAAA;AAAJ;AAPA;EAWI,qBAAA;AADJ;AAVA;EAcM,eAAA;EACA,gBAAA;AADN;AAQA;EACE,cAAA;AANF;AAKA;EAGI,eAAA;AALJ;AASA;EACE,YAAA;AAPF;AAMA;EAGI,aAAA;AANJ;AAUA;EACE,UAAA;AARF;AAOA;EAII,WAAA;AARJ;AAYA;EAEI,cAAA;AAXJ;AAeA;EACE,cAAA;AAbF","sourcesContent":["\n.unit-container {\n  padding: 5px 8px;\n  height: 100%;\n  overflow: auto;\n\n  .unit-header {\n    height: 41px;\n    border-bottom: 1px solid #ddd;\n  }\n\n  .unit-image {\n    padding: 20px 0 5px 0;\n\n    svg {\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n}\n\n\n\n.unit-warn {\n  color: #FF8A00;\n  .unit-path {\n    stroke: #FF8A00;\n  }\n}\n\n.unit-ok {\n  color: green;\n  .unit-path {\n    stroke: green;\n  }\n}\n\n.unit-error {\n  color: red;\n\n  .unit-path {\n    stroke: red;\n  }\n}\n\n.show-manual-color {\n  .manual-value {\n    color: #1677ff;\n  }\n}\n\n.manual-value {\n  color: #1677ff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
